import { useMemo, useState } from 'react'

import { IconButton } from '@twisto/components/atoms/button'
import type { InputProps } from '@twisto/components/atoms/input'
import { Input } from '@twisto/components/atoms/input'
import { EyeIcon, EyeOffIcon } from '@twisto/icons'

type Props = { name: string } & Omit<InputProps, 'type'>

export const PasswordInput = ({
  error = false,
  focused = false,
  ...props
}: Props) => {
  const [passwordShow, changePasswordShow] = useState(false)
  const other = { ...props, error, focused }

  const EndAdornment = useMemo(
    () => (
      <IconButton
        color="ghost"
        icon={passwordShow ? EyeOffIcon : EyeIcon}
        size="small"
        onClick={() => changePasswordShow(!passwordShow)}
      />
    ),
    [passwordShow]
  )

  return (
    <Input
      data-testid="password-input"
      endAdornment={EndAdornment}
      type={passwordShow ? 'text' : 'password'}
      {...other}
    />
  )
}
